import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import styled from 'styled-components'

import colors from 'components/utils/colors'
import LoadingIndicator from 'components/Shared/Select/components/LoadingIndicator'
import Option from 'components/Shared/Select/components/Option'
import DropdownIndicator from './components/DropdownIndicator'
import CustomIndicators from './components/CustomIndicators'

import SelectControl from './components/SelectControl'
import ValueContainer from './components/ValueContainer'
import Menu from './components/Menu'
import ClearIndicator from './components/ClearIndicator'
import Input from './components/Input'
import SingleValue from './components/SingleValue'

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
}
`

const StyledTitle = styled.label`
  font-family: Exo;
  font-size: 14px;
  font-weight: 500;
  line-height: 18px;
  color: ${colors.secondary20};
  padding-right: 8px;
  white-space: nowrap;
`

const SortDropdown = ({
  title, options, placeholder, value, onChange, clearActionTooltip,
  defaultSortField, defaultSortDir,
}) => {
  const handleFieldChange = (selectedItems) => {
    if (selectedItems) {
      onChange({ sortField: selectedItems['value'], sortDir: value.sortDir })
    } else {
      onChange({ sortField: defaultSortField, sortDir: defaultSortDir })
    }
  }

  const handleDirectionChange = () => {
    onChange({ sortField: value.sortField, sortDir: value.sortDir === 'desc' ? 'asc' : 'desc' })
  }

  const isClearable = (value.sortField === '' || value.sortField === defaultSortField) && value.sortDir === defaultSortDir
  const selectedOption = options.find(e => e.value === value.sortField)

  const components = {
    IndicatorSeparator: () => null,
    Control: SelectControl,
    ValueContainer: ValueContainer,
    Menu: Menu,
    DropdownIndicator: DropdownIndicator,
    LoadingIndicator: LoadingIndicator,
    ClearIndicator: ClearIndicator,
    Input: Input,
    SingleValue: SingleValue,
    Option: Option,
    IndicatorsContainer: CustomIndicators,
  }

  const hasMultipleOptions = Boolean(options.length > 1)

  return (
    <StyledWrapper data-test='sorted_by'>
      {title && <StyledTitle>{title}</StyledTitle>}
      <ReactSelect
        isSearchable={hasMultipleOptions}
        value={selectedOption}
        options={options}
        classNamePrefix='react-select'
        placeholder={placeholder}
        hideSelectedOptions={false}
        onChange={handleFieldChange}
        maxMenuHeight={null}
        isClearable={!isClearable}
        components={components}
        defaultMenuIsOpen={false} /* use it for debugging */
        //
        // custom props
        changeDirectionOnClick={handleDirectionChange}
        clearActionTooltip={clearActionTooltip}
        sortDir={value.sortDir}
      />
    </StyledWrapper>
  )
}

SortDropdown.propTypes = {
  title: PropTypes.string,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  value: PropTypes.object.isRequired,
  onChange: PropTypes.func.isRequired,
  clearActionTooltip: PropTypes.string,
  defaultSortField: PropTypes.string.isRequired,
  defaultSortDir: PropTypes.string.isRequired,
}

export default SortDropdown
